/* eslint-disable import/prefer-default-export */
/* eslint-disable max-len */
import styled, { css } from 'styled-components';
import { DayPicker } from 'react-day-picker';
import { detectIOS, detectMob } from '../../utilities/helperUtility';

const DEFAULT_FONT_SIZE = '16px';
const DEFAULT_PADDING = '5px';
const DEFAULT_PADDING_BOTTOM = '7px';
const DEFAULT_INACTIVE_COLOR = '#dce0e0';

function getMobileStyle() {
  return css`
    &.rdp:not(.rdp_interactionDisabled)
      .rdp-Day:not(.rdp-day_disabled):not(.rdp-day_selected):not(.rdp-day_hoverHighlight):hover {
      border-radius: unset;
      background-color: unset !important;
    }

    .rdp-day .day-tool-tip {
      opacity: 1 !important;
    }

    &:not(.rdp-day_selected):not(.rdp-day_hoverHighlight) .day-tool-tip {
      opacity: 0 !important;
    }
  `;
}

export const StyledDatePicker = styled(DayPicker)`
  ${(props) => {
    if (!props.styled) {
      return '';
    }

    const styles = props.styled;
    const { customStyle } = props;
    const styledColor = styled.color;
    const highlightedColor = styles.selector?.active.color;
    const hbgc = !detectIOS() && styles.selector?.hover.backgroundColor;
    const abgc = styles.selector?.active.backgroundColor;
    const ic = styles.inactive ? styles.inactive.color : null;
    const fs = styles ? styles.fontSize : DEFAULT_FONT_SIZE;
    const fontSize = customStyle ? customStyle.fontSize : fs;
    const padding = customStyle ? customStyle.padding : DEFAULT_PADDING;
    const paddingBottom = padding < DEFAULT_PADDING ? padding : DEFAULT_PADDING_BOTTOM;
    const inactiveColor = ic || DEFAULT_INACTIVE_COLOR;
    const isMobile = detectMob();

    return css`
      && {
        width: 100%;
        margin: 0;
        --rdp-cell-size: 30px;
        --rdp-caption-font-size: ${fontSize};
        --rdp-outline: 1px solid ${hbgc};
        --rdp-accent-color: ${abgc};

        .rdp-table {
          max-width: 100%;
          width: 100%;
        }

        .rdp-month {
          width: 100%;
          margin: 0;
        }

        .rdp_moved-left {
          display: inline-table;
          margin-right: 20px;
          width: calc(50% - 10px);
        }

        .rdp-day_disabled.rdp-day_fakeDisabled {
          color: rgba(72, 99, 150, 0.341);
        }

        .rdp-cell {
          width: 100%;
        }

        .rdp-cell .rdp-button[disabled]:not(.rdp-day_selected) {
          opacity: 1;
        }
        
        .rdp-day_selected:not(.rdp-day_disabled):not(.rdp-day_outside) 
        .rdp:not(.rdp_interactionDisabled)
          .rdp-day:not(.rdp-day_disabled):not(.rdp-day_selected):not(.rdp-day_outside) {
          border-radius: 0;
          transition: none;

          &:hover {
            border-radius: 0;
          }
        }

        .rdp-day_outside {
          color: unset;
        }

        .rdp-day_selected,
        .rdp-day_hoverHighlight {
          color: ${highlightedColor};
        }

        .rdp-day_selected:not(.rdp-day_disabled):not(.rdp-day_outside) {
          background-color: ${abgc};
        }

        &.rdp:not(.rdp_interactionDisabled)
          .rdp-day:not(.rdp-day_disabled):not(.rdp-day_selected):not(.rdp-day_hoverHighlight):hover {
          color: ${highlightedColor};
          background-color: ${hbgc};
        }

        .rdp-day {
          width: 100%;
          max-width: inherit;
          border-radius: 4px;
          margin: 0 auto;
          padding: ${padding};
          padding-bottom: ${paddingBottom};
          font-size: ${fontSize};
        }

        .rdp-day_today {
          color: ${styledColor};
        }

        .rdp-caption {
          margin-bottom: 0;
          padding: 0;
        }

        .rdp-caption_label {
          z-index: 0;
          padding: 0;
          font-weight: 400;
        }

        .rdp-nav {
          margin-right: 12px
        }

        .rdp-nav_button {
          border-radius: 4px;
          color: ${styledColor};

          &:not(:disabled):hover {
            color: ${highlightedColor};
            background-color: var(--rdp-accent-color);
          }
        }

        .rdp-nav_button_next {
          margin-left: 22px
        }

        .rdp-caption > div {
          font-weight: normal;
          padding: 0;
        }

        .rdp-day_disabled {
          color: ${inactiveColor};
        }

        .rdp-head {
          margin-top: 4px;
        }

        .rdp-head_row,
        .rdp-row {
          display: grid;
          grid-template-columns: repeat(7, 1fr);
          justify-items: center;
        }

        .rdp-head_cell {
          color: ${styledColor};
          padding: ${padding};
          font-size: ${fontSize};
          line-height: ${fontSize};
          font-weight: 400;
          height: auto;
          text-transform: capitalize;
        }

        .rdp-wrapper {
          padding-bottom: 1px;
          margin-top: 3px;
        }

        ${isMobile ? getMobileStyle() : ''}
      }
    `;
  }}
`;
